import { useState, useEffect } from 'react';
import API_ENDPOINTS from '../Config/api';
import apiClient from '../Config/apiClient';

export const useCurrentOrder = () => {
  const [orderData, setOrderData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCurrentOrder = async () => {
      try {
        setLoading(true);
        const response = await apiClient.get(API_ENDPOINTS.currentOrder);
        setOrderData(response.data);
      } catch (err) {
        console.error('Error fetching current order:', err);
        setError(err.message || 'Failed to fetch current order');
      } finally {
        setLoading(false);
      }
    };

    fetchCurrentOrder();
  }, []);

  return { orderData, loading, error };
};